import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@headlessui/react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import CargomaticAccounting from './CargomaticAccounting';
import PartnerAccounting from './PartnerAccounting';
import ConsigneeAccounting from './ConsigneeAccounting';
import SessionStore from '../../../../stores/SessionStore';

const PARTNER = 'Partner';
const CONSIGNEE = 'Consignee';
export default function Accounting({
  shipment,
  accessorialRequests,
  onAddCustomAdjustment,
  onAddShipperCostAdjustment,
  onAddBaseCost,
  onApproveBaseCost,
  refreshShipment,
  onRemoveLineItem,
}) {
  const { t } = useTranslation();
  function renderTabs(tabs, hasPartner, hasConsignee) {
    return (
      <Tab.Group as="div" data-testid="undefined-977e32fa">
        <Tab.List data-testid="undefined-49f7314d">
          <div data-testid="div-93c2e112" className="space-x-4">
            {tabs.map((tab, index) => (
              <Tab as={Fragment} key={tab.slug}>
                {({ selected }) => {
                  const className = classnames(
                    'px-3 py-2 font-medium rounded-md text-sm',
                    {
                      'bg-green': selected,
                      'text-white': selected,
                      'bg-white': !selected,
                      'text-gray-700': !selected,
                      'hover:text-gray-700': !selected,
                    },
                  );
                  return (
                    <button
                      data-testid={`button-bed61ab2-${index}`}
                      className={className}
                    >
                      {t(tab.localizationSlug)}
                    </button>
                  );
                }}
              </Tab>
            ))}
          </div>
        </Tab.List>
        <Tab.Panels data-testid="undefined-7bf97afd" className="mt-6">
          <Tab.Panel data-testid="undefined-91391700">
            <CargomaticAccounting
              shipment={shipment}
              accessorialRequests={accessorialRequests}
              refreshShipment={refreshShipment}
              onAddCustomAdjustment={onAddCustomAdjustment}
              onAddBaseCost={onAddBaseCost}
              onApproveBaseCost={onApproveBaseCost}
              onRemoveLineItem={onRemoveLineItem}
              onAddShipperCostAdjustment={(lineItem) =>
                onAddShipperCostAdjustment(lineItem)
              }
            />
          </Tab.Panel>
          {hasPartner && (
            <Tab.Panel data-testid="undefined-cacb2f4e">
              <PartnerAccounting shipment={shipment} />
            </Tab.Panel>
          )}
          {hasConsignee && (
            <Tab.Panel data-testid="undefined-52639f21">
              <ConsigneeAccounting shipment={shipment} />
            </Tab.Panel>
          )}
        </Tab.Panels>
      </Tab.Group>
    );
  }

  function renderAccounting() {
    let { managed_receivables, managed_payables } = shipment;
    managed_receivables = managed_receivables || [];
    managed_payables = managed_payables || [];

    const hasPartnerItems = !![
      ...managed_payables,
      ...managed_receivables,
    ].find((i) => i.payee_type === PARTNER);
    const hasConsigneeItems = !![
      ...managed_payables,
      ...managed_receivables,
    ].find((i) => i.payer_type === CONSIGNEE);

    const tabs = [
      {
        slug: 'Cargomatic',
        name: 'Cargomatic',
        localizationSlug: 'CARGOMATIC',
      },
    ];

    if (hasPartnerItems) {
      tabs.push({
        slug: 'Partner',
        name: 'Partner',
        localizationSlug: 'PARTNER',
      });
    }

    if (hasConsigneeItems) {
      tabs.push({
        slug: 'Consignee',
        name: 'Consignee',
        localizationSlug: 'CONSIGNEE',
      });
    }

    if (
      !SessionStore.isGodAdmin() ||
      (!hasConsigneeItems && !hasPartnerItems)
    ) {
      return (
        <CargomaticAccounting
          shipment={shipment}
          accessorialRequests={accessorialRequests}
          refreshShipment={refreshShipment}
          onAddCustomAdjustment={onAddCustomAdjustment}
          onAddBaseCost={onAddBaseCost}
          onApproveBaseCost={onApproveBaseCost}
          onRemoveLineItem={onRemoveLineItem}
          onAddShipperCostAdjustment={onAddShipperCostAdjustment}
        />
      );
    }
    return renderTabs(tabs, hasPartnerItems, hasConsigneeItems);
  }

  return <div data-testid="Container-4e5eb0b2">{renderAccounting()}</div>;
}

Accounting.propTypes = {
  onAddCustomAdjustment: PropTypes.func.isRequired,
  shipment: PropTypes.object,
  accessorialRequests: PropTypes.array,
};
